import { render, staticRenderFns } from "./VendorAccounts.vue?vue&type=template&id=2738d1ec&scoped=true"
import script from "./VendorAccounts.vue?vue&type=script&lang=js"
export * from "./VendorAccounts.vue?vue&type=script&lang=js"
import style0 from "./VendorAccounts.vue?vue&type=style&index=0&id=2738d1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738d1ec",
  null
  
)

export default component.exports